module.exports = __webpack_public_path__ + "img/logo-chaleur-80-de.ecc98e0c.svg";